/* eslint-disable lodash/chaining, no-restricted-syntax, guard-for-in */

export function clearFilter() {
  this.filtering = false;
  this.__emit('clearFilter', {
    data: this.filteredItems
  });
  this.filteredItems = [];
  this.safeTocElementFn($t => {
    $t.removeClass('filtered')
      .find('li.filter-pass')
      .removeClass('filter-pass')
      .filter('.group')
      .find('>.label>.badge.filter-count.show')
      .removeClass('show');
  });
}

export function filter(options) {
  const self = this;
  this.__emit('filterBefore', { data: options });
  this.clearFilter();
  if (_.isNil(options) || _.isEmpty(options)) {
    return;
  }
  const promise = this.__doFilter(options);
  if (_.isNil(promise)) {
    return;
  }
  
  return promise
    .then(data => {
      this.filteredItems = data.items;
      self.log('Filtered:', data.items.length);
      this.__emit('filtered', { data });
      return data;
    })
    // eslint-disable-next-line no-unused-vars
    .catch(err => _.noop());
}

function _trimKeyword(str) {
  return _.chain(str).trim().toLower().value();
}

function _trimFilterOptions(options) {
  for (const key in options) {
    const val = options[key];
    if (val.length) {
      options[key] = _trimKeyword(val);
    } else {
      delete options[key];
    }
  }
}

function _updateDomFilter(item) {
  const $parentsGroup = item.$element
    .addClass('filter-pass')
    .parents('li.group');
  $parentsGroup.addClass('filter-pass expanded').each((ndx, el) => {
    const $group = $(el);
    const $countBadge = $group.find('>.label>.badge.filter-count');
    const nChildren = $group.find('>.list-wrapper>li.md.filter-pass').length;
    if (nChildren > 0) {
      $countBadge.text(nChildren).addClass('show');
    }
  });
}

function _asyncFilter(aList, fnFilter, options) {
  const self = this;
  return new Promise((resolve, reject) => {
    const filteredItems = [];
    try {
      aList.forEach(item => {
        if (!self.filtering) {
          throw new Error('stopped filtering');
        }
        const isMatched = fnFilter(item);
        if (!isMatched) {
          return;
        }
        filteredItems.push(item);
        _updateDomFilter(item);
      });
      resolve({
        items: filteredItems,
        options,
      });
    } catch (err) {
      reject(err);
    }
  });
}

function _emitFilterEvent(bool, type, data) {
  if (!bool) {
    return;
  }
  this.__emit(`filterMatched${_.startCase(type)}`, data);
}

export function doFilter(options) {
  _trimFilterOptions(options);

  if (_.isEmpty(options)) {
    return;
  }

  this.filtering = true;
  this.setTocElementClass('filtered');
  const emitFilterEvent = _emitFilterEvent.bind(this);

  return _asyncFilter.apply(this, [
    this.docItems,
    item => {
      const { title, body } = options;
      const hasTitle = !_.isNil(title);
      const hasBody = !_.isNil(body);
      const eventData = {
        target: item,
        options,
      };
      let bMatchTitle = false;
      if (hasTitle) {
        const label = _.toLower(item.label);
        bMatchTitle = _.includes(label, title);
        if (!hasBody) {
          emitFilterEvent(bMatchTitle, 'title', eventData);
          return bMatchTitle;
        }
      }
      if (hasBody) {
        const contents = _.toLower(item.data.body);
        const bMatchBody = _.includes(contents, body);
        if (hasTitle) {
          const bMatchedAll = bMatchBody && bMatchTitle;
          emitFilterEvent(bMatchedAll, 'title', eventData);
          emitFilterEvent(bMatchedAll, 'body', eventData);
          return bMatchedAll;
        }
        emitFilterEvent(bMatchBody, 'body', eventData);
        return bMatchBody;
      }
      return false;
    },
    options,
  ]);
}
